.spacer {
    display: block;
}

.nano {
    height: var(--spacer-block-nano);
}

.micro {
    height: var(--spacer-block-micro);
}

.xxxlarge {
    height: var(--spacer-block-xxxlarge);
}
